import type { FaireProductEntity } from "../../entity_types/product";

export const p_8pefnn93zy: FaireProductEntity = {
  token: "p_8pefnn93zy",
  type: "product",
  name: "Jarritos Passion Fruit (12.5oz) (Mexico) 6 pack",
  brandToken: "b_5fqs9qr72c",
  brandName: "Pops Distro Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/38c5267373e42dd68f1274633c701041e4f181229deaba82453714ac688e77c5.png",
  galleryImageUrls: [],
  priceDollars: 19,
  description:
    "Jarritos Passion Fruit (12.5oz) | Mexico | 6ct Case\n\nA vibrant Mexican soda delivering bold passion fruit flavor with refreshing carbonation 🥭🥤. A tropical standout that drives curiosity and repeat purchases in any cooler.\n\n✨ Why Retailers Love It\n\n * \nAuthentic Mexican soda with strong brand recognition\n\n * \nUnique passion fruit flavor differentiates from standard sodas\n\n * \nIconic glass bottle enhances perceived quality\n\n * \n12.5oz size ideal for grab-and-go cooler placement\n\n * \nHigh demand in Hispanic and international beverage sections\n\n📦 Case Details\n\n * \nBrand: Jarritos\n\n * \nFlavor: Passion Fruit (Maracuyá)\n\n * \nNet Volume: 12.5oz per bottle\n\n * \nPack Size: 6 bottles per case\n\n * \nOrigin: Mexico\n\n * \nCategory: Imported Soda / Glass Bottle Beverage\n\n🏪 Ideal For\n\n * \nHispanic beverage sections\n\n * \nInternational soda coolers\n\n * \nConvenience and grab-and-go displays\n\n * \nTropical soda collections\n",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:54.195Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
